import React from "react"
import { Center, Box, HStack, VStack, Stack, useColorModeValue } from "@chakra-ui/react"
import { motion } from "framer-motion"

export const MotionBox = motion(Box)
export const MotionVStack = motion(VStack)
export const MotionStack = motion(Stack)
export const MotionHStack = motion(HStack)

export const Wrapper = (props: any) => {
    const bgColor = useColorModeValue("gray.50", "gray.900")

    return (
        <Box p={5} bgColor={bgColor} {...props}>
            <Center>{props.children}</Center>
        </Box>
    )
}
